import React from 'react';
import { Chart } from 'react-chartjs-2';
import dayjs from 'dayjs';
import './chartSetup.ts';
import { EURO_FORMAT } from './chartSetup.ts';
import { SEMANTIC } from '../../theme/statusColors.ts';

interface MonthPoint {
  month: string; // 'YYYY-MM'
  count: number;
  value: number;
}

interface OrdersTrendChartProps {
  data: MonthPoint[];
}

// Grafico misto: barre = valore ordinato (€, asse sx), linea = numero ordini (asse dx)
const OrdersTrendChart: React.FC<OrdersTrendChartProps> = ({ data }) => {
  const labels = data.map(p => dayjs(p.month, 'YYYY-MM').format('MM/YYYY'));

  const chartData = {
    labels,
    datasets: [
      {
        type: 'bar' as const,
        label: 'Valore (€)',
        data: data.map(p => p.value),
        backgroundColor: `${SEMANTIC.info}99`,
        borderColor: SEMANTIC.info,
        borderWidth: 1,
        borderRadius: 4,
        yAxisID: 'y',
        order: 2,
      },
      {
        type: 'line' as const,
        label: 'N. ordini',
        data: data.map(p => p.count),
        borderColor: SEMANTIC.warning,
        backgroundColor: SEMANTIC.warning,
        tension: 0.3,
        pointRadius: 3,
        yAxisID: 'y1',
        order: 1,
      },
    ],
  };

  const options: any = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: 'index' as const, intersect: false },
    plugins: {
      legend: { position: 'bottom' as const, labels: { boxWidth: 12, font: { size: 11 } } },
      tooltip: {
        callbacks: {
          label: (ctx: any) =>
            ctx.dataset.yAxisID === 'y'
              ? `${ctx.dataset.label}: ${EURO_FORMAT.format(ctx.parsed.y)}`
              : `${ctx.dataset.label}: ${ctx.parsed.y}`,
        },
      },
    },
    scales: {
      y: {
        position: 'left' as const,
        beginAtZero: true,
        ticks: {
          font: { size: 11 },
          callback: (v: any) => EURO_FORMAT.format(Number(v)),
        },
      },
      y1: {
        position: 'right' as const,
        beginAtZero: true,
        grid: { drawOnChartArea: false },
        ticks: { font: { size: 11 }, precision: 0 },
      },
      x: { ticks: { font: { size: 11 } } },
    },
  };

  return (
    <div style={{ height: 280 }}>
      <Chart type="bar" data={chartData as any} options={options} />
    </div>
  );
};

export default OrdersTrendChart;
